import { Button, Center } from "@mantine/core";
import { EmptyState } from "@mountaya/studio-react";
import { Link } from "@tanstack/react-router";
import { IconCompassOutline18, IconHouseOutline18 } from "nucleo-ui-outline-18";
import { useTranslation } from "react-i18next";

import { ICON_SIZE } from "@mountayaapp/theme";

/**
 * RouteNotFound is the application-wide 404 screen TanStack Router renders for an
 * unmatched path — wired as the router's defaultNotFoundComponent. It frames the
 * miss in the shared EmptyState block with a single affordance back to the home
 * route, which redirects on to the studio (or the sign-in flow for an anonymous
 * visitor).
 */
export const RouteNotFound = () => {
  const { t } = useTranslation();

  return (
    <Center mih="100vh">
      <EmptyState
        action={
          <Button
            component={Link}
            leftSection={<IconHouseOutline18 size={ICON_SIZE.sm} />}
            to="/"
            variant="default"
          >
            {t("routeNotFound.home")}
          </Button>
        }
        description={t("routeNotFound.description")}
        icon={<IconCompassOutline18 size={ICON_SIZE.xl} />}
        title={t("routeNotFound.title")}
      />
    </Center>
  );
};
